import request from '../../utils/request';

export function login(params) {
  return request({ url: 'user/login', params, headers: 'json' });
}

export function smsSend(params) {
  return request({ url: `user/smsSend`, params, headers: 'json' });
}
